import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import Handler from "../../../Helpers/Handler";
import { textCapitalize } from "../../../Helpers/Utils";

const FAQ_CATEGORIES = ["Car", "Booking", "Payment", "Refund", "Trip Protection", "Support"];

const FaqFormModal = ({ faq, onClose, onSaved }) => {
    const modalRef = useRef(null);
    const bsModalRef = useRef(null);
    const mode = faq?.faqId ? "edit" : "create";
    const [category, setCategory] = useState(faq?.category || "Car");
    const [question, setQuestion] = useState(faq?.question || "");
    const [answer, setAnswer] = useState(faq?.answer || "");
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        const el = modalRef.current;
        if (!el || !window.bootstrap) return undefined;
        const instance = window.bootstrap.Modal.getOrCreateInstance(el);
        bsModalRef.current = instance;
        const handleHidden = () => onClose?.();
        el.addEventListener("hidden.bs.modal", handleHidden);
        instance.show();
        return () => {
            el.removeEventListener("hidden.bs.modal", handleHidden);
            instance.hide();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onSubmit = async () => {
        if (!question.trim() || !answer.trim()) {
            toast.error("Question and answer are required");
            return;
        }
        setSaving(true);
        const payload = { category, question: question.trim(), answer: answer.trim() };
        const response = mode === "create"
            ? await Handler({ method: "post", url: "/admin/client/faq/register", data: payload })
            : await Handler({ method: "patch", url: `/admin/client/faq/${faq.faqId}`, data: payload });

        if (response?.success) {
            toast.success(response?.data?.message || "Saved successfully");
            onSaved?.();
        } else {
            toast.error(textCapitalize(response?.data?.message || "Unable to save FAQ"));
        }
        setSaving(false);
    };

    return (
        <div className="modal fade" tabIndex="-1" ref={modalRef} aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content border-0 rounded-4">
                    <div className="modal-header">
                        <h5 className="modal-title fw-semibold">{mode === "create" ? "New FAQ" : "Edit FAQ"}</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="row g-3">
                            <div className="col-12">
                                <label className="form-label">Category</label>
                                <select className="form-select" value={category} onChange={(e) => setCategory(e.target.value)}>
                                    {FAQ_CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}
                                </select>
                            </div>
                            <div className="col-12">
                                <label className="form-label">Question</label>
                                <input type="text" className="form-control" value={question} onChange={(e) => setQuestion(e.target.value)} maxLength={300} />
                            </div>
                            <div className="col-12">
                                <label className="form-label">Answer</label>
                                <textarea className="form-control" rows={5} value={answer} onChange={(e) => setAnswer(e.target.value)} maxLength={3000} />
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button>
                        <button type="button" className="btn btn-primary" onClick={onSubmit} disabled={saving}>
                            {saving ? "Saving..." : "Save"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FaqFormModal;
